// PDP urgency block (snippets/pdp-urgency.liquid): delivery-date estimate
// with a live countdown to the daily dispatch cutoff, and a low-stock
// indicator that follows the selected variant. Both read real data - the
// cutoff/off-days come from section settings, stock from Shopify inventory.
(function () {
  var root = document.querySelector('[data-pdp-urgency]');
  if (!root) return;

  var DUBAI_OFFSET_MS = 4 * 60 * 60 * 1000; // UAE is UTC+4 all year, no DST
  var DAY_MS = 24 * 60 * 60 * 1000;

  // ---------------------------------------------------------------
  // Delivery estimate
  // ---------------------------------------------------------------
  var deliveryEl = root.querySelector('[data-urgency-delivery]');
  var cutoffHour = parseInt(root.getAttribute('data-cutoff-hour'), 10);
  if (isNaN(cutoffHour) || cutoffHour < 0 || cutoffHour > 23) cutoffHour = 14;
  var offDays = (root.getAttribute('data-off-days') || '')
    .split(',')
    .map(function (d) { return parseInt(d, 10); })
    .filter(function (d) { return d >= 0 && d <= 6; });
  // Every weekday switched off would loop forever below - ignore that config.
  if (offDays.length >= 7) offDays = [];
  var locale = root.getAttribute('data-locale') === 'ar' ? 'ar-AE' : 'en-GB';

  function isOff(date) {
    return offDays.indexOf(date.getUTCDay()) !== -1;
  }

  // All dates below are "Dubai wall-clock" values stored in a Date's UTC
  // fields (real time shifted by +4h), so getUTC* reads Dubai time on any
  // visitor device regardless of its own timezone.
  function computeDelivery(nowMs) {
    var now = new Date(nowMs + DUBAI_OFFSET_MS);
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
    var cutoff = new Date(today.getTime() + cutoffHour * 60 * 60 * 1000);
    var beforeCutoff = !isOff(today) && now.getTime() < cutoff.getTime();

    var ship = today;
    if (!beforeCutoff) {
      ship = new Date(today.getTime() + DAY_MS);
      while (isOff(ship)) ship = new Date(ship.getTime() + DAY_MS);
    }
    var delivery = new Date(ship.getTime() + DAY_MS);
    while (isOff(delivery)) delivery = new Date(delivery.getTime() + DAY_MS);

    return {
      beforeCutoff: beforeCutoff,
      msToCutoff: beforeCutoff ? cutoff.getTime() - now.getTime() : 0,
      delivery: delivery,
      isTomorrow: delivery.getTime() - today.getTime() === DAY_MS
    };
  }

  function formatDate(date) {
    try {
      return new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(date);
    } catch (e) {
      return date.getUTCDate() + '/' + (date.getUTCMonth() + 1);
    }
  }

  function formatCountdown(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    var uh = root.getAttribute('data-unit-h');
    var um = root.getAttribute('data-unit-m');
    var us = root.getAttribute('data-unit-s');
    if (h > 0) return h + uh + ' ' + (m < 10 ? '0' : '') + m + um;
    return m + um + ' ' + (s < 10 ? '0' : '') + s + us;
  }

  function strong(text, extraClass) {
    var el = document.createElement('strong');
    if (extraClass) el.className = extraClass;
    el.textContent = text;
    return el;
  }

  function renderDelivery() {
    var info = computeDelivery(Date.now());
    var template = root.getAttribute(info.beforeCutoff ? 'data-tpl-before' : 'data-tpl-after') || '';
    var dateText = formatDate(info.delivery);
    // Arabic uses its own comma (U+060C), not the Latin one.
    if (info.isTomorrow) dateText = root.getAttribute('data-tomorrow') + (locale === 'ar-AE' ? '، ' : ', ') + dateText;

    // Built from text nodes (never innerHTML) - the template only carries
    // the two %TIME%/%DATE% markers.
    deliveryEl.textContent = '';
    template.split(/(%TIME%|%DATE%)/).forEach(function (part) {
      if (part === '%TIME%') deliveryEl.appendChild(strong(formatCountdown(info.msToCutoff), 'velo-urgency__time'));
      else if (part === '%DATE%') deliveryEl.appendChild(strong(dateText));
      else if (part) deliveryEl.appendChild(document.createTextNode(part));
    });
    return info;
  }

  if (deliveryEl) {
    var tick = function () {
      var info = renderDelivery();
      // Seconds are only on screen during the last hour; otherwise the
      // text changes once a minute, so there is no need to tick faster.
      var delay = info.beforeCutoff && info.msToCutoff < 60 * 60 * 1000 ? 1000 : 30000;
      window.setTimeout(tick, delay);
    };
    tick();
  }

  // ---------------------------------------------------------------
  // Low stock - follows the selected variant
  // ---------------------------------------------------------------
  var stockRow = root.querySelector('[data-urgency-stock]');
  var stockJson = root.querySelector('[data-urgency-stock-json]');
  if (!stockRow || !stockJson) return;

  var stock = {};
  try {
    stock = JSON.parse(stockJson.textContent) || {};
  } catch (e) {
    return;
  }
  var threshold = parseInt(root.getAttribute('data-low-stock-threshold'), 10) || 0;
  var countEl = stockRow.querySelector('[data-urgency-stock-count]');
  var meterEl = stockRow.querySelector('[data-urgency-stock-meter]');
  var form = document.getElementById('ProductForm');
  var idInput = form ? form.querySelector('input[name="id"]') : null;

  var maxStock = 0;
  Object.keys(stock).forEach(function (id) {
    if (stock[id] > maxStock) maxStock = stock[id];
  });

  function renderStock() {
    var id = idInput ? idInput.value : '';
    var tracked = Object.prototype.hasOwnProperty.call(stock, id);
    var qty = tracked ? stock[id] : 0;
    // "Pack of N" option cards are fulfilled from the Single variant's
    // stock (their own variant carries 0), so fall back to the product's
    // real stock instead of hiding the indicator or showing "0 left".
    if (tracked && qty <= 0) qty = maxStock;

    var show = qty > 0 && qty <= threshold;
    stockRow.hidden = !show;
    if (!show) return;
    if (countEl) countEl.textContent = String(qty);
    if (meterEl) meterEl.style.width = Math.min(100, Math.max(6, Math.round((qty / threshold) * 100))) + '%';
  }

  if (form) {
    form.addEventListener('change', function () {
      // product-form.js writes the resolved variant id in its own change
      // handler - read it after that has run.
      window.setTimeout(renderStock, 0);
    });
  }
  renderStock();
})();
